<template>
	<v-card class="filters">
		<v-switch
			inset
			color="accent"
			v-model="showFinished"
			label="Mostrar circuitos terminadas"
			@change="filterChanged"
		></v-switch>
		<v-switch
			inset
			color="accent"
			v-model="showNotStarted"
			label="Mostrar circuitos sin empezar"
			@change="filterChanged"
		></v-switch>
	</v-card>
</template>

<script>
	export default {
		data: () => ({
			showFinished: false,
			showNotStarted: false,
		}),
		methods: {
			filterChanged() {
				this.$emit("filterChanged", {
					finished: this.showFinished,
					notStarted: this.showNotStarted,
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.filters {
		margin-top: 2em;
		padding: 2em;
	}
</style>